import React from 'react';

import Row from 'react-bootstrap/Row';

export default function Olfactory() {

    return (
        <div className='bg-light mt-4 mb-4 p-3'>
            <Row>
                <h1>And that... is an opportunity.</h1>
            </Row>
            <Row className='mt-3 mb-3 p-3 justify-content-center'>
                <img src="/logo373.jpg" alt="Logo" className="img-fluid" style={{ width: '80%' }} />
            </Row>
        </div>
    )
}
